<template lang="html">
<div class="player-cell">
  <div
    class="player-puce"
    :style="{'background-color': cellData.color}">
  </div>
    <p class="player-name">{{cellData.name}}</p>
    <div class="player-enable switch">
      <input
        type="checkbox"
        :id="'player#' + cellIndex"
        v-model="cellData.enable"
      />
      <label :for="'player#' + cellIndex"></label>
    </div>
  </div>
</div>
</template>

<script>
import TableCell from '../view/table/TableCell.vue'

export default {
  name: 'PlayerCell',
  mixins: [ TableCell ],
}
</script>

<style lang="stylus">
@import '../styles/common'

puce-size = 40px
player-height = 70px

.player-cell
  position relative
  text-align right
  height player-height
  line-height player-height
  padding-left (puce-size + 20px)

.player-puce
  content ''
  position absolute
  top (player-height - puce-size) * 0.5
  left 0
  display block
  width puce-size
  height puce-size
  border-radius puce-size * 0.5

.player-name
  display inline-block
  font-size 1.4em
  margin 0
  line-height player-height
  vertical-align middle
  float left

.player-enable
  line-height normal
  vertical-align middle
</style>



// WEBPACK FOOTER //
// PlayerCell.vue?769621da